/*
 * @Author: cheng
 * @Date: 2018-12-21 11:30:21
 * @Last Modified by: cheng
 * @Last Modified time: 2018-12-21 14:50:35
 */

import * as React from 'react';
import { ReferenceConfig } from './reference-textarea';
import { API, REFERENCE_SUFFIX } from '@config/index';
import { ParameterConfig } from '@interface/index';
import { cloneDeep } from 'lodash';

export const referenceUtils = {
  toString: (refData: ReferenceConfig) => {
    return refData.text;
  },
  toReference: async (
    text: string,
    parameterMap: { [key: string]: ParameterConfig }
  ) => {

    const res: ReferenceConfig = {
      text: '',
      labels: new Map()
    };

    if (!text) {
      return res;
    }

    const nameCache: any = {};
    const typeCache: any = {};

    const textArr: string[] = [];
    let refArr: string[] = [];

    let span = '';
    let textArrNext = '';

    for (const c of text) {

      if (c === '$') {
        let contained = false;

        if (span.startsWith('$')) {

          if (span.indexOf('_param') !== -1) {
            contained = true;
          } else {
            for (const [k, pm] of Object.entries(parameterMap)) {
              if (span.indexOf(k) !== -1) {
                contained = true;
                break;
              }
            }
          }
        }

        if (contained) {
          refArr.push(span + '$');
          span = '';
          textArr.push(textArrNext);
          textArrNext = '';
        } else {
          textArrNext += span;
          span = '$';
        }
      } else {
        span += c;
      }
    }

    textArrNext += span;
    textArr.push(textArrNext);

    let composeArr: any = [];

    refArr.forEach((ref: string) => {
      let tem = ref;
      tem = tem.substring(1, ref.length - 1);

      tem.split('.').forEach((key: string) => {
        let keyTemp = key;

        if (keyTemp.indexOf(REFERENCE_SUFFIX.CLOSURE) !== -1) {
          keyTemp = keyTemp.split('_')[0];
        } else if (keyTemp.indexOf('[')) {
          keyTemp = keyTemp.split('[')[0];
        }

        if (parameterMap[keyTemp]) {
          nameCache[keyTemp] = parameterMap[keyTemp].name;
        } else if (keyTemp !== REFERENCE_SUFFIX.ORIGINAL) {
          nameCache[keyTemp] = '';
        }
      });
    });

    let nameRes: any = [];

    if (
      Object.keys(nameCache).filter(
        (key: string) => key && nameCache[key] === ''
      ).length !== 0
    ) {

      nameRes = await API.common
        .getAttributeCompletedInfoById(
          Object.keys(nameCache).filter(
            (key: string) => key && nameCache[key] === ''
          )
        )
        .catch((err: any) => {
          throw new Error(err.message);
        });

      nameRes.forEach((item: any) => {
        nameCache[item.attribute_id] = item.name;
      });
    }

    if (
      Object.keys(typeCache).filter(
        (key: string) => key && typeCache[key] === ''
      ).length
    ) {
      nameRes = await API.composite
        .getItemListService(
          Object.keys(typeCache).filter(
            (key: string) => key && typeCache[key] === ''
          )
        )
        .catch((err: any) => {
          throw new Error(err.message);
        });

      nameRes.forEach((item: any) => {
        typeCache[item.id] = item.name;
      });
    }

    refArr = refArr.map((ref: string) => {
      let tem = ref;
      let name = '';
      const ids: string[] = [];
      tem = tem.substring(1, ref.length - 1);
      tem.split('.').forEach((key: string, i: number) => {
        const keyTemp = key;
        if (keyTemp === 'it') {
          name += `it`;
          ids.push('it');
        } else if (keyTemp === 'index') {
          name += `index`;
          ids.push('index');
        } else if (keyTemp === REFERENCE_SUFFIX.ORIGINAL) {
          name += `.${REFERENCE_SUFFIX.ORIGINAL}`;
          ids.push(REFERENCE_SUFFIX.ORIGINAL);
        } else if (keyTemp === REFERENCE_SUFFIX.SIZE) {
          name += `.${REFERENCE_SUFFIX.SIZE}`;
          ids.push(keyTemp);
        } else if (keyTemp.indexOf(REFERENCE_SUFFIX.CLOSURE) !== -1
          || keyTemp.indexOf('[') !== -1) {

          let idTemp = keyTemp;
          let suffixTemp = '';

          if (idTemp.indexOf('[') !== -1) {
            suffixTemp = `[${idTemp.split('[')[1]}`;
            idTemp = idTemp.split('[')[0];
          }

          if (idTemp.indexOf(REFERENCE_SUFFIX.CLOSURE) !== -1) {
            idTemp = idTemp.split('_')[0];
          }

          name += `${i === 0 ? '' : '.'}${nameCache[idTemp]}${suffixTemp}`;
          ids.push(keyTemp);
        } else {
          name += `${i === 0 ? '' : '.'}${nameCache[keyTemp] || keyTemp}`;
          ids.push(`${keyTemp}`);
        }
      });

      res.labels.set(`$${name}$`, ids);
      return `$${name}$`;
    });

    textArr.forEach((str, i) => {
      composeArr.push(str);

      if (refArr[i]) {
        composeArr.push(refArr[i]);
      }
    });

    if (refArr.length > textArr.length) {
      composeArr = [...composeArr, ...refArr.slice(textArr.length)];
    }

    res.text = composeArr.join('');
    // res.text = codeExpToShow(res.text);

    return res;
  },
  toServer: ({ text, labels }: ReferenceConfig) => {
    let nextText = cloneDeep(text);
    for (const [key, value] of labels) {
      nextText = nextText.split(key).join(`$${value.join('.')}$`);
    }
    // nextText = codeExpToServer(nextText);
    return nextText;
  },
  regularData: () => undefined
};

// function codeExpToShow(text: string) {
//   const regex = /(?<!\\+)\$\{.*?[^\\]\}/g;
//   const matched = text.match(regex);
//   let result = cloneDeep(text);

//   for (const m of (matched || [])) {
//     const r = m.substr(2, m.length - 3);
//     result = result.replace(m, `<${r}>`);
//   }
//   return result;
// }

// function codeExpToServer(text: string) {
//   const regex = /(?<!\\+)<.*?[^\\]>/g;

//   const matched = text.match(regex);

//   let result = cloneDeep(text);

//   for (const m of (matched || [])) {
//     const r = m.substr(1, m.length - 2);
//     result = result.replace(m, `\${${r}}`);
//   }

//   return result;
// }

// 获取光标位置，包括划词
export const getRangePosition = (ref: HTMLTextAreaElement) => {

  // start
  const rangeData = { start: 0, end: 0 };
  const selectText = (window as any).getSelection().toString();

  rangeData.start = ref.selectionStart || 0;
  rangeData.end = ref.selectionEnd || 0;

  if (selectText) {
    return { selectText, rangeX: rangeData.start, rangeX2: rangeData.end };
  }

  return { rangeX: rangeData.start, rangeX2: rangeData.end };
};

export const getTextLabelPositions = (ref: ReferenceConfig) => {
  // 储存文本位置
  let index = 0;
  const res: any = [];

  let tmpText = cloneDeep(ref.text);
  let tmpText2 = cloneDeep(ref.text);
  for (const [key, value] of ref.labels) {
    tmpText = tmpText.split(key).join(`<#ref#>`);
    tmpText2 = tmpText2.split(key).join(`<#${key}#>`);
  }

  const textArr = tmpText.split(`<#ref#>`);
  const refArr = (tmpText2.match(/<#\$[\s\S]*?\$#>/gi) || [])
    .map((item: string) => item.substr(2, item.length - 4));

  let composeArr: any = [];

  textArr.forEach((str, i) => {
    composeArr.push(str);

    if (refArr[i]) {
      composeArr.push(refArr[i]);
    }
  });

  if (refArr.length > textArr.length) {
    composeArr = [...composeArr, ...refArr.slice(textArr.length)];
  }

  composeArr.forEach((str: string) => {
    if (str.startsWith('$') && str.endsWith('$')) {
      res.push([index, index + str.length - 1]);
    }

    index += str.length;
  });

  return res;
};

export const ReferenceTextRender = (props: {
  parameterMap: {
    [key: string]: ParameterConfig
  };
  text: string,
  style?: any
}) => {
  const [result, setResult] = React.useState('');
  React.useEffect(() => {
    referenceUtils.toReference(props.text, props.parameterMap)
      .then((ret: any) => {
        setResult(ret.text);
      });
  });
  return <span style={props.style} key={result}>{result}</span>;
};
